import { render, staticRenderFns } from "./add-details.vue?vue&type=template&id=01474b5e&scoped=true"
import script from "./add-details.vue?vue&type=script&lang=ts"
export * from "./add-details.vue?vue&type=script&lang=ts"
import style0 from "./add-details.vue?vue&type=style&index=0&id=01474b5e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01474b5e",
  null
  
)

export default component.exports